import { render, staticRenderFns } from "./DetailMetric.vue?vue&type=template&id=acb735f6"
import script from "./DetailMetric.vue?vue&type=script&lang=js"
export * from "./DetailMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports